import { createBrowserRouter } from "react-router-dom";
import Main from "../Layout/Main.jsx";
import Home from "../Pages/Home/Home.jsx";
import About from "../Pages/About/About.jsx";
import Careers from "../Pages/Careers/Careers.jsx";
import PrivacyPolicy from "../Pages/PrivacyPolicy/PrivacyPolicy.jsx";
import CookiePolicy from "../Pages/CookiePolicy/CookiePolicy.jsx";
import TermsConditions from "../Pages/TermsConditions/TermsConditions.jsx";
import Contact from "../Pages/Contact/Contact.jsx";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <Main></Main>,
        children: [
            { 
                path: "/",
                element: <Home />
            },
            { 
                path: "About",
                element: <About />
            },
            { 
                path: "Careers",
                element: <Careers />
            },
            { 
                path: "PrivacyPolicy",
                element: <PrivacyPolicy />
            },
            { 
                path: "TermsConditions",
                element: <TermsConditions />
            },
            { 
                path: "CookiePolicy",
                element: <CookiePolicy />
            },
            { 
                path: "Contact",
                element: <Contact />
            },
        ],
    }
])
